var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user)?_c('div',[_vm._t("default")],2):_c('div',{staticClass:"confirm-button"},[_c('el-button',{staticClass:"w-100",attrs:{"type":"primary"},on:{"click":_vm.login}},[_vm._v(_vm._s(_vm.$t('Connect Wallet')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }